<template>
  <div>
    <el-dialog
      top="20px"
      :visible.sync="visiable"
      width="1496px"
      title="开方"
      @open="handleShow"
    >
      <div v-loading="loading" class="tcm-list-con flex flex-row" style="min-height: 500px;">

        <Tcm
          v-for="item in data"
          :key="item.id"
          class="tcm"
          :row="item"
          @choose="handleRowClick"
          @detail="handleDetail"
        />
      </div>
      <template #title>
        <div class="title-con pb-10 flex flex-row align-center">
          <span class="title mr-10">开方</span>
          <span class="sub-title self-end  mr-10">
            <img alt="warning" src="@/assets/tcm/Vector.png" class="warning-icon">
            处方由 AI 匹配生成，内容仅供参考，请医疗人员结合患者实际病情酌情选择和使用。
          </span>
        </div>
      </template>
    </el-dialog>
    <el-button class="ik-user-btn" size="mini" type="primary" @click="handleOpen">
      <slot name="default" />
    </el-button>
    <el-dialog title="详情" :visible.sync="detailVisiable">
      <TcmDetail :row="detail" />
    </el-dialog>
  </div>
</template>

<script>
import { DataTableMixin } from "@/components/ik/form/popup/mixins/tableMethodFindByKeyWord"
import Tcm from "./comp/Tcm.vue"
import { getById, postData } from "@/api/ik/data/dataApi"
import TcmDetail from "@/components/TCMRx/comp/TcmDetail.vue"

// import TcmDetail from "@/components/TCMRx/comp/TcmDetail.vue"

export default {
  name: "IkFormPopupSelect",
  components: {
    TcmDetail,
    Tcm
    // TcmDetail
  },
  mixins: [DataTableMixin],
  props: {
    require: {
      type: Boolean,
      default: false
    },
    name: { type: String, default: "" },
    code: { type: String, default: "" },
    value: { type: String, default: "" },
    valueCode: { type: String, default: "code" }
  },
  data() {
    return {
      result: "",
      detail: {},
      detailVisiable: false,
      visiable: false,
      prescriptionName: '',
      filedList: [
        { code: 'name', name: '名称', config: { align: "center", width: 120 }},
        { code: 'symContent', name: '主诉', config: { align: "center", width: 280 }},
        { code: 'fdmContent', name: '四诊', config: { align: "center", width: 280 }},
        { code: 'diagContent', name: '西医病', config: { align: "center", width: 280 }},
        { code: 'chDiagContent', name: '中医病', config: { align: "center", width: 280 }},
        { code: 'chYndromeContent', name: '中医症', config: { align: "center", width: 280 }},
        { code: 'chTherapyContent', name: '治法', config: { align: "center", width: 280 }}

      ]
    }
  },
  computed: {
    getRequire() {
      return this.require
    }
  },
  provide() {
    return {
      TcmRx: this
    }
  },
  watch: {
    value(val) {
      this.result = val
    }
  },
  mounted() {
    this.result = this.value
  },
  methods: {
    /**
     * 显示详情
     * @param row
     */
    handleDetail(row) {
      this.detail = { ...row }
      this.detailVisiable = true
    },
    /**
     * 显示事件
     */
    handleShow() {
      this.$emit("show")
    },
    /**
     * 行被点击
     * @param row
     */
    handleRowClick(row) {
      getById(this.url, row.id)
        .then(res => {
          this.$emit("onPopupClick", res.data)
          this.visiable = false
        })
    },
    open() {
      this.search(() => {
        this.visiable = true
      })
    },
    handleOpen() {
      this.$emit("handleOpenClick")
    },
    searchPrescription() {
      const data = {
        data: {
          storeCode: 'CS00001',
          name: this.prescriptionName
        }
      }
      postData('clinic/treatment/stdprescription/stdserverprescription/find/getstdserverprescription', JSON.stringify(data)).then(res => {
        console.log(res)
      })
    }
  }
}
</script>

<style scoped>
::v-deep.require > .el-input__inner {
  border: red 1px solid;
}

.item {
  width: calc(100% - 30px)
}
</style>
<style lang="scss" scoped>
.tag-wrapper {
  min-height: 24px;
  max-width: 295px;
  flex-wrap: wrap;
}

.el-form-item {
  margin-bottom: 12px;
  width: 100%;
}

.el-form-item__label {
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-form-item__content {
  width: calc(100% - 180px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

<style lang="scss" scoped>
.tcm-list-con {
  padding: 0 20px 20px 20px;
  max-width: 1496px;
  overflow-x: scroll;

  .tcm {
    margin-right: 20px;
  }
}

.title-con {
  border-bottom: 1px solid #E5E6EB;

  .title {
    font-family: PingFang SC, PingFang SC, serif;
    font-weight: bold;
    font-size: 16px;
    color: #1D2129;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .sub-title {
    font-family: PingFang SC, PingFang SC, serif;
    font-weight: normal;
    font-size: 14px;
    color: #CE7720;
    line-height: 14px;
    text-align: center;
    font-style: normal;
    text-transform: none;

    .warning-icon {
      width: 12px;
      height: 12px;
    }
  }
}
</style>
